import DeleteIcon from "@mui/icons-material/Delete";

import PaperFragment from "../../../../helper-components/misc/PaperFragment";
import StackedHeader from "../../../../helper-components/misc/StackedHeader";
import DataGridTable from "../../../../helper-components/table/DataGridTable";

import { columns, defaultTableOptions } from "../../../../helper-functions/table/playlists";
import { deletePlaylists, queryPlaylists } from "../../../../helper-functions/api/playlistQueries";

import { getLanguage } from "../../../../config/language/language";

/**
 * Table showing playlists.
 * If no data found, show error message instead.
 */
export default function PlaylistsTable(props) {
    const playlists = props.backend.playlists;

    const showDeleteDialog = () => {
        props.showDialog({
            title: "Delete playlists",
            message: `Are you sure you want to delete the ${playlists.selected.length} selected playlists?
            This action will not delete any resources.`,
            actionTitle: "Delete",
            actionColor: "error",
            callback: (confirm) => handleDelete(confirm)
        });
    };

    const handleDelete = (confirm) => {
        if (!confirm) return;

        const ids = playlists.selected.map((playlist) => playlist.id);
        deletePlaylists(props, { body: { ids }, ids });
    };

    return (
        <PaperFragment
            className="tour-playlists-3 tour-playlists-4"
            title={
                <StackedHeader
                    {...props}
                    title="Playlists"
                    subtitle="View and manage playlists."
                    icons={[
                        {
                            icon: <DeleteIcon />,
                            tooltip: "Delete selected playlists",
                            disabled: playlists.selected.length < 1,
                            onClick: showDeleteDialog
                        }
                    ]}
                />
            }
            value={
                <DataGridTable
                    {...props}
                    {...defaultTableOptions}
                    rowHeight={60}
                    states={playlists}
                    columns={columns(props)}
                    query={(options) => queryPlaylists(props, options)}
                    empty={getLanguage().NO_PLAYLISTS_FOUND}
                    refresh={10}
                />
            }
        />
    );
}
